import { Auth, API } from "aws-amplify";
import { errorServices } from "../actions";
import { CONSTANTES } from "../../web/utils/Constantes";
import Utils from "../../web/utils/Validate";
import { v4 as uuidv4 } from "uuid";
import CryptoJS from "crypto-js";
import aws4 from "aws4";

const PATH = "/";
export const callService =
  (method, nameService, request, handlerAction) => async (dispatch) => {
    try {
      let headerUser = {};

      if (method == "POST" && nameService == "afiliacion") {
        let uidGen = uuidv4();
        // console.log(uidGen);
        var ciphertext = CryptoJS.AES.encrypt(uidGen, uidGen).toString();
        headerUser = { User: uidGen + "|||" + ciphertext };
        //headerUser['x-aws-access-autorization'] = localStorage.getItem("x-aws-access-autorization");
        //headerUser['x-aws-access-autorization'] = Utils.getLocalStorageValueForRegex(/^CognitoIdentityServiceProvider\..*\.accessToken$/);
      }
      // console.log(headerUser);
      if (nameService == "afiliacion" || nameService == "remesas") {
        headerUser["x-aws-access-autorization"] =
          Utils.getLocalStorageValueForRegex(
            /^CognitoIdentityServiceProvider\..*\.accessToken$/
          );
      }

      let data = {
        headers: headerUser,
        response: true,
      };
      let response = "";
      if ("POST" === method.toUpperCase()) {
        data.body = request;
        response = await API.post("portal-cobranzas", PATH + nameService, data);
      }
      if ("GET" === method.toUpperCase()) {
        data.queryStringParameters = request;
        response = await API.get("portal-cobranzas", PATH + nameService, data);
      }
      if ("PUT" === method.toUpperCase()) {
        data.body = request;
        response = await API.put(
          "portal-cobranzas",
          PATH + `${request.id}/${nameService}`,
          data
        );
      }
      if ("DELETE" === method.toUpperCase()) {
        response = await API.del(
          "portal-cobranzas",
          PATH + `${request.id}/${nameService}`,
          data
        );
      }
      if ("CUSTOMPUT" === method.toUpperCase()) {
        data.body = request;
        response = await API.put(
          "portal-cobranzas",
          PATH + `${nameService}/${request.id}/${request.url}`,
          data
        );
      }
      if ("GETROL" === method.toUpperCase()) {
        // console.log("Entre aqui..****")
        data.queryStringParameters = request;

        if (nameService === "usuario") {
          const resp = await callGuess(request);
          response = { ...resp, data: resp, status: 200 };
        } else {
          response = await API.get("api-cognito", PATH + nameService, data);
        }
      }
      if (handlerAction !== null) {
        dispatch(handlerAction(response.data.detalleRespuesta));
      }
      return response;
    } catch (error) {
      console.log(error);
      console.log("ERROR1 RESPONSE:", error.response);
      if (!error.response) {
        throw Error();
      } else if (error.response.status === 403) {
        new Promise((resolve, reject) => {
          setTimeout(function () {
            //localStorage.clear();
            Auth.signOut();
            resolve(true);
          }, 500);
        }).then(() => {
          const indexURL = window.location.href.indexOf(
            CONSTANTES.RUTA.basename
          );
          const urlRedirect = window.location.href.substring(0, indexURL);
          window.location.href =
            urlRedirect + CONSTANTES.RUTA.basename + CONSTANTES.RUTA.login;
        });
      }
      dispatch(errorServices(error));
    }
  };

const callGuess = async (request) => {
  let data = {
    headers: {},
    response: true,
  };

  const valueGuess = Utils.getLocalStorageValueGuess();

  const credentials = {
    accessKeyId: valueGuess.Credentials.AccessKeyId,
    secretAccessKey: valueGuess.Credentials.SecretKey,
  };

  const opts = {
    host: process.env.REACT_APP_URL_API,
    path: "/validar/usuario",
    service: "execute-api",
    region: process.env.REACT_APP_REGION,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-amz-security-token": valueGuess.Credentials.SessionToken,
    },
  };
  aws4.sign(opts, credentials);

  const authorizationHeader = opts.headers["Authorization"];

  const xAmzDateHeader = opts.headers['X-Amz-Date'];

  const response = await fetch(
    `${process.env.REACT_APP_URL_API}/validar/usuario`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-amz-security-token": valueGuess.Credentials.SessionToken,
        Authorization: authorizationHeader,
        'X-Amz-Date': xAmzDateHeader,
      },
      body: JSON.stringify(request),
    }
  );
  return response.json();
};

export const callServiceUsuarios = async (method, nameService, request) => {
  return new Promise(async (resolve, reject) => {
    try {
      let headerUser = {};

      let data = {
        headers: headerUser,
        response: true,
      };
      let response = "";
      if ("POST" === method.toUpperCase()) {
        data.body = request;
        response = await API.post("usuarios", PATH + nameService, data);
      }
      if ("GET" === method.toUpperCase()) {
        data.queryStringParameters = request;
        response = await API.get("usuarios", PATH + nameService, data);
      }
      if ("PUT" === method.toUpperCase()) {
        data.body = request;
        response = await API.put("usuarios", PATH + nameService, data);
      }
      if ("DELETE" === method.toUpperCase()) {
        response = await API.del("usuarios", PATH + nameService, data);
      }
      console.log(response);
      resolve(response.data.payload);
    } catch (error) {
      console.log(error);
      console.log("ERROR1 RESPONSE:", error.response);
      if (!error.response) {
        console.log("ANTES 1er CATCH");
        console.log(error.response);
        console.log("DESPUES 1er CATCH");
        reject(error);
      } else if (error.response.status === 403) {
        new Promise((resolve, reject) => {
          setTimeout(function () {
            //localStorage.clear();
            Auth.signOut();
            resolve(true);
          }, 500);
        }).then(() => {
          const indexURL = window.location.href.indexOf(
            CONSTANTES.RUTA.basename
          );
          const urlRedirect = window.location.href.substring(0, indexURL);
          window.location.href =
            urlRedirect + CONSTANTES.RUTA.basename + CONSTANTES.RUTA.login;
        });
      } else if (error.response.status == 406) {
        //this.props.mostrarModal('mensajeUsuario', null, 'Su sesión ha sido cerrada desde otro dispositivo, se cerrará la sesión');
        new Promise((resolve, reject) => {
          setTimeout(function () {
            //localStorage.clear();
            Auth.signOut();
            resolve(true);
          }, 1500);
        }).then(() => {
          const indexURL = window.location.href.indexOf(
            CONSTANTES.RUTA.basename
          );
          const urlRedirect = window.location.href.substring(0, indexURL);
          window.location.href =
            urlRedirect + CONSTANTES.RUTA.basename + CONSTANTES.RUTA.login;
        });
      } else if (error.response.status == 504) {
        //this.props.mostrarModal('mensajeUsuario', null, 'Su sesión ha sido cerrada desde otro dispositivo, se cerrará la sesión');
        console.log("ANTESSSSS");
        console.log(error);
        console.log("DESPUES");
        reject(error);
      }
    }
  });
};
